// @ts-nocheck
import React, { useState, useEffect, Fragment } from "react"

import { Flex } from "../../container-components"
import Popover from "@mui/material/Popover";
import { Icon, Typography } from "../../typo-components"


export default function PopoverIcon(props) {
	const { iconConfig, popoverConfig } = props
	const { isClick, margin, color } = props

	const [anchor, setAnchor] = useState(() => null)

	let iconStyle = {}
	if (iconConfig?.style) iconStyle = iconConfig.style

	let anchorOrigin = { vertical: "center", horizontal: "center" }
	if (popoverConfig?.anchorOrigin) anchorOrigin = popoverConfig.anchorOrigin

	const handleClick = (event) => setAnchor(event.currentTarget)
	const handleClose = () => setAnchor(null)

	useEffect(() => {
		handleClose()
	}, [isClick])

	return (
		<Fragment>
			<Icon
				name={iconConfig.name}
				margin={margin || "0"}
				size={iconConfig.size || "small"}
				color={color || "tertiary"}
				style={{ cursor: "pointer", ...iconStyle }}
				onMouseEnter={handleClick}
				onMouseLeave={!popoverConfig?.isClick && handleClose}
				onClick={popoverConfig?.isClick ? handleClick : null}
			></Icon>

			<Popover
				id="hover-popover"
				open={anchor}
				anchorEl={anchor}
				onClose={handleClose}
				anchorOrigin={anchorOrigin}
				transformOrigin={{ vertical: "top", horizontal: "right" }}
				style={{
					pointerEvents: popoverConfig.isClick ? "auto" : "none",
					zIndex: 1000
				}}
				disableRestoreFocus
			>
				<Flex>
					<Flex id="popover-content" style={{ padding: "10px" }}>
						{(() => {
							const { text, jsx } = popoverConfig

							let textColor = "tertiary"
							if (popoverConfig?.style?.color) textColor = popoverConfig?.style?.color
							else if (color) textColor = color

							if (text) {
								return (
									<Typography variant="t6" color={textColor} style={{ whiteSpace: "break-spaces" }}>
										{text}
									</Typography>
								)
							} else return <Fragment>{jsx}</Fragment>
						})()}
					</Flex>
				</Flex>
			</Popover>
		</Fragment>
	)
}
